import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Arrowrecovery = () => {
  return (
    <div className="arrow_recovery p-100" style={{ background: "#1F8763" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banenr_content">
              <h2 style={{ color: "#fff" }}>
                Arrow Recovery – Ecommerce Platform For Catalytic Converters
              </h2>
              <p style={{ color: "#fff" }}>
                Conventionally, developing an Ecommerce mobile app or website
                for a very niche product is a very difficult undertaking. Niche
                products have a different set of market dynamics and you need to
                factor them in if you want to make this app work.
              </p>
              <p style={{ color: "#fff" }}>
                ArrowRecovery was a one-of-kind, Ecommerce platform for
                Catalytic Converters that we developed. This platform had
                incredible, custom features primed to make the platform suitable
                for all kinds of needs related to the marketplace.
              </p>
              <p style={{ color: "#fff" }}>
                The platform had a product view option, real time rates viewer
                for catalytic converters, search by category, year or model
                option, delivery finalization feature and much more, making this
                platform a super success and enabling the business owner to get
                maximum conversions from it.
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/solution/ecommerce/Arrow-Recovery.webp"
              alt="Arrow Recovery-Tekrevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Arrowrecovery;
